import service from './index';

export default {
  async getSupplierAddresses () {
    const response = await service.get('supplier/addresses', {
      hideSpinner: true,
      hideErrorMessage: true,
    });
    return response;
  },
  async getSupplierDeliveryPeriod () {
    const response = await service.get('supplier/delivery-period', {
      hideSpinner: true,
      hideErrorMessage: true,
    });
    return response;
  },
  async getSupplierDetail () {
    const response = await service.get('supplier/detail', {
      hideSpinner: true,
      hideErrorMessage: true,
    });
    return response;
  },
};
